import React from 'react';
import Icon from '../../../components/AppIcon';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';

const AdvancedFilters = ({ filters, onChange, reportType }) => {
  const updateFilter = (key, value) => {
    onChange({ ...filters, [key]: value });
  };

  return (
    <div className="bg-card border border-border rounded-lg p-4">
      <h3 className="font-semibold text-foreground mb-4 flex items-center gap-2">
        <Icon name="Filter" size={18} />
        Filters
      </h3>
      <div className="space-y-4">
        {/* Date Range */}
        <div>
          <label className="text-sm font-medium text-foreground mb-2 block">Date Range</label>
          <Select
            value={filters?.dateRange}
            onChange={(e) => updateFilter('dateRange', e?.target?.value)}
            className="w-full"
          >
            <option value="7">Last 7 Days</option>
            <option value="30">Last 30 Days</option>
            <option value="90">Last 90 Days</option>
            <option value="180">Last 6 Months</option>
            <option value="365">Last Year</option>
            <option value="custom">Custom Range</option>
          </Select>
        </div>

        {/* Custom Date Range */}
        {filters?.dateRange === 'custom' && (
          <>
            <div>
              <label className="text-sm font-medium text-foreground mb-2 block">Start Date</label>
              <Input
                type="date"
                value={filters?.startDate || ''}
                onChange={(e) => updateFilter('startDate', e?.target?.value)}
                className="w-full"
              />
            </div>
            <div>
              <label className="text-sm font-medium text-foreground mb-2 block">End Date</label>
              <Input
                type="date"
                value={filters?.endDate || ''}
                onChange={(e) => updateFilter('endDate', e?.target?.value)}
                className="w-full"
              />
            </div>
          </>
        )}

        {/* Status Filter (for sales, revenue, reconciliation) */}
        {(reportType === 'sales' || reportType === 'revenue' || reportType === 'reconciliation') && (
          <div>
            <label className="text-sm font-medium text-foreground mb-2 block">Status</label>
            <Select
              value={filters?.status}
              onChange={(e) => updateFilter('status', e?.target?.value)}
              className="w-full"
            >
              <option value="all">All Status</option>
              {reportType === 'reconciliation' ? (
                <>
                  <option value="matched">Matched</option>
                  <option value="unmatched">Unmatched</option>
                  <option value="disputed">Disputed</option>
                </>
              ) : (
                <>
                  <option value="completed">Completed</option>
                  <option value="pending">Pending</option>
                  <option value="failed">Failed</option>
                </>
              )}
            </Select>
          </div>
        )}

        {/* Payment Method Filter (for sales) */}
        {reportType === 'sales' && (
          <div>
            <label className="text-sm font-medium text-foreground mb-2 block">Payment Method</label>
            <Select
              value={filters?.paymentMethod}
              onChange={(e) => updateFilter('paymentMethod', e?.target?.value)}
              className="w-full"
            >
              <option value="all">All Methods</option>
              <option value="cash">Cash</option>
              <option value="card">Card</option>
              <option value="stripe">Stripe</option>
              <option value="paypal">PayPal</option>
            </Select>
          </div>
        )}

        {/* Category Filter (for sales) */}
        {reportType === 'sales' && (
          <div>
            <label className="text-sm font-medium text-foreground mb-2 block">Category</label>
            <Select
              value={filters?.category}
              onChange={(e) => updateFilter('category', e?.target?.value)}
              className="w-full"
            >
              <option value="all">All Categories</option>
              <option value="supplements">Supplements</option>
              <option value="apparel">Apparel</option>
              <option value="equipment">Equipment</option>
              <option value="beverages">Beverages</option>
            </Select>
          </div>
        )}
      </div>
    </div>
  );
};

export default AdvancedFilters;